import { graphql } from 'gatsby'
import React from 'react'

// Note: After adding the slice to Prismic and running `npm run type-graphql`,
// replace `any` with `PrismicPageDataBodyConfigurableCta` from generated types
import ConfigurableCta, {
  ConfigurableCtaContent,
} from 'src/components/organisms/ctas/configurableCta'

type Props = {
  slice: any // TODO: Replace with PrismicPageDataBodyConfigurableCta after type generation
}

const ConfigurableCtaSlice = ({ slice }: Props) => {
  const content: ConfigurableCtaContent = {
    anchor: slice.primary?.anchor ?? undefined,
    eyebrowText: slice.primary?.eyebrow_text ?? undefined,
    eyebrowSize: slice.primary?.eyebrow_size ?? undefined,
    headline: slice.primary?.headline ?? '',
    headlineSize: slice.primary?.headline_size ?? undefined,
    hasTrademark: slice.primary?.has_trademark ?? undefined,
    description: slice.primary?.description ?? undefined,
    descriptionSize: slice.primary?.description_size ?? undefined,
    link: slice.primary?.link ?? undefined,
    linkText: slice.primary?.link_text ?? undefined,
    linkStyle: slice.primary?.link_style ?? undefined,
    image: slice.primary?.image?.gatsbyImageData ?? undefined,
    imageAlt: slice.primary?.image?.alt ?? undefined,
    imageLayout: slice.primary?.image_layout ?? undefined,
    mobileOnly: slice.primary?.mobile_only ?? undefined,
    themeColor: slice.primary?.theme_color ?? undefined,
  }

  return <ConfigurableCta content={content} />
}

export default ConfigurableCtaSlice

export const configurableCtaFragment = graphql`
  fragment PageDataBodyConfigurableCta on PrismicPageDataBodyConfigurableCta {
    primary {
      anchor
      eyebrow_text
      eyebrow_size
      headline
      headline_size
      has_trademark
      description {
        richText
      }
      description_size
      link {
        ...DynamicLinkFragment
      }
      link_text
      link_style
      image {
        alt
        gatsbyImageData(layout: CONSTRAINED)
      }
      image_layout
      mobile_only
      theme_color
    }
  }
`
